/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RateRefreshResponse
 */
export interface RateRefreshResponse {
    /**
     * Whether a fresh rate check was enqueued.
     * @type {boolean}
     * @memberof RateRefreshResponse
     */
    enqueued: boolean;
}

/**
 * Check if a given object implements the RateRefreshResponse interface.
 */
export function instanceOfRateRefreshResponse(value: object): value is RateRefreshResponse {
    if (!('enqueued' in value) || value['enqueued'] === undefined) return false;
    return true;
}

export function RateRefreshResponseFromJSON(json: any): RateRefreshResponse {
    return RateRefreshResponseFromJSONTyped(json, false);
}

export function RateRefreshResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateRefreshResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'enqueued': json['enqueued'],
    };
}

export function RateRefreshResponseToJSON(json: any): RateRefreshResponse {
    return RateRefreshResponseToJSONTyped(json, false);
}

export function RateRefreshResponseToJSONTyped(value?: RateRefreshResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enqueued': value['enqueued'],
    };
}

